import styled from "styled-components";

export const Wrapper = styled.div`
    
 display:grid;
 grid-auto-flow:column;

`

export const UserDiv = styled.div`
    
 display:grid;
 grid-auto-flow:row;
 font-size: xx-small;
 padding: 5px;
 margin: 10px;
 border-radius: 10px;
 background-color: ${({status})=>(status ? "var(--primaryColor)" : "var(--secondaryColor)")};

    `
 export const MessageDiv = styled.div`
    
 display:grid;
 grid-auto-flow:column;
 font-size: large;
 max-width: 80%;
 
 padding: 5px;
 margin: 10px;
 border-radius: 10px;
 background-color: ${({user})=>(user ? "var(--primaryColor)" : "var(--secondaryColor)")};
 
 margin-left:${({user})=>(user ? "auto" : "")};

    `   